import React, { forwardRef, useCallback, useEffect, useImperativeHandle } from 'react';

import Banner from '@rover/kibble/patterns/Banner';

import { defaultProps, Props } from '.';

const Toast = forwardRef(function Toast(
  { autoHideDuration, onClose, ...bannerProps }: Props,
  ref: React.Ref<{ dismiss: () => void }>
): JSX.Element {
  const [animation, setAnimation] = React.useState({ transform: 'translateY(100%)', opacity: 0 });

  const handleClose = useCallback((): void => {
    setAnimation({ transform: 'translateY(100%)', opacity: 0 });
    setTimeout(() => {
      onClose?.();
    }, 500);
  }, [onClose]);

  useImperativeHandle(ref, () => ({
    dismiss: handleClose,
  }));

  useEffect(() => {
    setAnimation({ transform: 'translateY(-50%)', opacity: 1 });

    const timeout = setTimeout(() => {
      handleClose();
    }, autoHideDuration || defaultProps.autoHideDuration);

    return () => {
      clearTimeout(timeout);
    };
  }, [autoHideDuration, handleClose]);

  return (
    <Banner
      {...bannerProps}
      onClose={handleClose}
      containerProps={{
        position: 'absolute',
        bottom: '20px',
        ...bannerProps.containerProps,
        sx: {
          transition: 'transform 0.4s ease, opacity 0.4s ease;',
          boxShadow: '0px 1px 4px #1B1F2352',
          width: ['92%', '678px'],
          ...animation,
          ...bannerProps.containerProps?.sx,
        },
      }}
      fontSize="200"
    />
  );
});

export default Toast;
